import React from 'react';

type Props = {
  headingClass: string;
  headings: string;
};

const Text = (props: Props): JSX.Element => {
  const { headings } = props;
  const headingClass = props.headingClass ? props.headingClass : 'caf-submessage';

  return (
    <div key={headings} className={headingClass}>{headings}</div>
  );
};

export default Text;
